import React, { useContext } from "react";
import { FilterContext } from "../filters-context";
import useMediaQuery from "@mui/material/useMediaQuery";

const ThemeFilter = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const onThemeClick = () => {
    if (filters.openedFilter === "theme") {
      setOpenedFilter(null);
    } else {
      setOpenedFilter("theme");
    }
  };
  const selectTheme = (theme) => {
    setTheme(theme);
  };

  const handleChange = (event) => {
    const theme = guideFilters.theme.find((theme) => {
      return Number(event.target.value) === theme.id;
    });
    setTheme(theme);
  };
  const { filters, setTheme, setOpenedFilter, resetFilters } =
    useContext(FilterContext);
  return (
    <>
      {guideFilters && guideFilters.theme && guideFilters.theme.length > 0 && (
        <div
          className={`filter-container ${
            filters.openedFilter === "theme" ? "is-open" : ""
          }`}
        >
          <button
            className={`filter-button ${
              filters.theme && filters.theme.label ? "is-selected" : ""
            }`}
            onClick={() => {
              onThemeClick();
            }}
          >
            {filters.theme && filters.theme.label
              ? filters.theme.label
              : "Filtrer par thématique"}
          </button>
          {isMobile ? (
            <select
              name="theme-select"
              id=""
              onChange={handleChange}
              value={filters.theme?.id || ""}
            >
              <option value={""}>Tous les thèmes</option>
              {guideFilters.theme.map((theme) => {
                return (
                  <option key={theme.id} value={theme.id}>
                    {theme.label}
                  </option>
                );
              })}
            </select>
          ) : (
            <ul className="filter-list">
              {filters.theme && filters.theme.label && (
                <li>
                  <button
                    onClick={() => {
                      selectTheme(null);
                    }}
                  >
                    Toutes les thématiques
                  </button>
                </li>
              )}
              {guideFilters.theme.map((theme) => (
                <li key={theme.id}>
                  <button
                    onClick={() => {
                      selectTheme(theme);
                    }}
                    id={theme.id}
                  >
                    {theme.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </>
  );
};

export default ThemeFilter;
